var _excluded = ["size", "type"],
  _excluded2 = ["size", "type"],
  _excluded3 = ["size", "type"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
var StyledLabel = styled(_ref => {
  var {
      size,
      type
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", rest);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n"])), props => css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        color: ", ";\n        font-size: ", ";\n    "])), props.theme.colors.secondary, props.size));
var StyledText = styled(_ref2 => {
  var {
      size,
      type
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement("span", rest);
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", "\n"])), props => css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        font-size: ", ";\n    "])), props.size));
var StyledTitle = styled(_ref3 => {
  var {
      size,
      type
    } = _ref3,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement("div", rest);
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    ", "\n"])), props => css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        font-size: ", ";\n        font-weight: 500;\n        letter-spacing: 2px;\n        margin: 0.5rem 0;\n        text-transform: uppercase;\n    "])), props.size));
var Typography = props => {
  var {
    type
  } = props;
  switch (type) {
    case 'label':
      return /*#__PURE__*/React.createElement(StyledLabel, props);
    case 'text':
      return /*#__PURE__*/React.createElement(StyledText, props);
    case 'title':
      return /*#__PURE__*/React.createElement(StyledTitle, props);
    default:
      return null;
  }
};
Typography.defaultProps = {
  size: 'inherit',
  type: 'text'
};
Typography.propTypes = {
  /**
   * Any valid string that can be used as CSS font-size.
   */
  size: PropTypes.string,
  /**
   * The type of component.
   * The available options are: 'label' | 'text' | 'title'
   */
  type: PropTypes.oneOf(['label', 'text', 'title'])
};
export default Typography;